import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import ExperienceAccordion from '../../containers/experienceAccordion/ExperienceAccordion.js';
// import experience from '../../shared/experience_data.json';
import "./Experience.css";
import { Fade } from "react-reveal";

const experience = {
	title: "Experience",
	subtitle: "Work and Volunteership",
	description:
		"Currently I am working as an Apprentice at Quantum Computing India. I have also experience of Web Development, worked on official website of IIIT Agartala. I have been volunteering as Technical lead of Girlscript, Agartala and previously volunteered as Vice President of Robotics Club, NIT Agartala.",
	header_image_path: "experience.svg",
	sections: [
		{
			title: "Apprenticeship",
			experiences: [
				
				{
					title: "Teaching Assitant",
					company: "Quantum Computing India",
					company_url: "https://quantumcomputingindia.com/",
					logo_path: "qci_logo.png",
					duration: "August 2020 - PRESENT",
					location: "Work From Home",
					description:
						"Quantum Computing India is building a community of tech, science, policy and art professionals interested in everything around Quantum Computing in India.",
					color: "#4285F4"
				}
				
			]
		},

		{
			title: "Volunteering Experience",
			experiences: [

				{
					title: "Student Developer",
					company: "Developers Club, NIT Agartala",
					company_url: "",
					logo_path: "coding_logo.png",
					duration: "April 2020 - June 2020",
					location: "Work From Home",
					description:
						"Developers Club, NIT Agartala is a non-profit coding society at NIT Agartala campus. As a team project, we have developed the official website of IIIT Agartala ",
					color: "#4285F4"
				},
				
				{
					title: "Technical Lead",
					company: "GirlScript Agartala, Tripura",
					company_url: "https://www.linkedin.com/company/girlscript-agartala/?originalSubdomain=in",
					logo_path: "girlscript_logo.jpeg",
					duration: "June 2020 - PRESENT",
					location: "Agartala, Tripura",
					description:
						"GirlScript is a section-8 NON PROFIT company registered under the government of India on the 2nd of June, 2017. GirlScript is open for all organisation and supports beginners in technology and programming. It supports diversity by reserving 50% seats for women & IGBT in all it's programs worldwide. ",
					color: "#4285F4"
				},

				{
					title: "Vice President",
					company: "ANARC, Robotics Club, NIT Agartala",
					company_url: "http://anarc.in/?i=1",
					logo_path: "anarc_logo.png",
					duration: "August 2019 - July 2020",
					location: "NIT Agartala",
					description:
						"ANARC, Robotics Club, NIT Agartala is a non-profit community in NIT Agartala campus, which helps students to gain basic knowledge of Robotics and Electronics through regular activities, weekend classes and participating in various Robotics comptitions like E-yantra. ",
					color: "#4285F4"
				}
				
				
			]
		}
	]
};

class Experience extends Component {
	render() {
		return (
			<div className="experience-main">
				<Header />
				<div className="basic-experience">
					<Fade bottom duration={1000} distance="40px">
						<div className="experience-heading-div">
							<div className="experience-heading-img-div">
								<img
									src={require(`../../assests/images/${experience["header_image_path"]}`)}
								    alt=""
								/>
							</div>
							<div className="experience-heading-text-div">
								<h1 className="experience-heading-text">{experience.title}</h1>
								<h3 className="experience-heading-sub-text">
									{experience["subtitle"]}
								</h3>
								<p className="experience-header-detail-text subTitle">
									{experience["description"]}
								</p>
							</div>
						</div>
					</Fade>
				</div>
				<ExperienceAccordion sections={experience["sections"]} />
				<Footer />
			</div>
		);
	}
}

export default Experience;
